/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020-2022 (original work) Open Assessment Technologies SA ;
 */

/**
 * Dynamic theming service
 * TODO the theming should be handled by generating the index.html and manifest
 *
 * @param {Object} [theme]
 * @param {string} [theme.title] - the page title
 * @param {Object} [theme.favicon] - the page favicon (with href and type)
 * @returns {Object} the theming service
 */
export default function themingServiceFactory({ title, favicon } = {}) {
    return {
        /**
         * Update the page title
         */
        updateTitle() {
            if (title && title.length) {
                document.title = title;
            }
        },

        /**
         * Update the page favicon
         */
        updateFavicon() {
            if (favicon && favicon.href) {
                const head = document.head;
                //remove all favicon first
                for (let currentIcon of head.querySelectorAll('link[rel=icon]')) {
                    head.removeChild(currentIcon);
                }
                const link = document.createElement('link');
                link.rel = 'shortcut icon';
                link.href = favicon.href;
                link.type = favicon.type || 'image/x-icon';
                head.appendChild(link);
            }
        },

        /**
         * Load the theme
         * @returns {Promise}
         */
        load() {
            this.updateTitle();
            this.updateFavicon();

            return Promise.resolve();
        }
    };
}
